import { Global } from '@emotion/react'

export const Fonts = () => (
  <Global
    styles={`
      @font-face {
        font-family: 'Formata Pro';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('/fonts/formata_pro_light.woff2') format('woff2'),
          url('/fonts/formata_pro_light.ttf') format('truetype'),
          url('/fonts/formata_pro_light.otf') format('opentype');
      }
      @font-face {
        font-family: 'Formata Pro';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/formata_pro_regular.woff2') format('woff2'),
          url('/fonts/formata_pro_regular.ttf') format('truetype'),
          url('/fonts/formata_pro_regular.otf') format('opentype');
      }
      @font-face {
        font-family: 'Formata Pro';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/formata_pro_medium.woff2') format('woff2'),
          url('/fonts/formata_pro_medium.ttf') format('truetype'),
          url('/fonts/formata_pro_medium.otf') format('opentype');
      }
      @font-face {
        font-family: 'Gotham';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/gotham_book.woff2') format('woff2'),
          url('/fonts/gotham_book.ttf') format('truetype'),
          url('/fonts/gotham_book.otf') format('opentype');
      }
      @font-face {
        font-family: 'Gotham';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/gotham_medium.woff2') format('woff2'),
          url('/fonts/gotham_medium.ttf') format('truetype'),
          url('/fonts/gotham_medium.otf') format('opentype');
      }
      @font-face {
        font-family: 'Gotham';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/gotham_bold.woff2') format('woff2'),
          url('/fonts/gotham_bold.ttf') format('truetype'),
          url('/fonts/gotham_bold.otf') format('opentype');
      }
      @font-face {
        font-family: 'Gotham';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/gotham_black.woff2') format('woff2'),
          url('/fonts/gotham_black.ttf') format('truetype'),
          url('/fonts/gotham_black.otf') format('opentype');
      }
      @font-face {
        font-family: 'Fishmonger';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/fishmonger/fishmonger_400.woff2') format('woff2'),
          url('/fonts/fishmonger/fishmonger_400.ttf') format('truetype'),
          url('/fonts/fishmonger/fishmonger_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'Fishmonger';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/fishmonger/fishmonger_700.woff2') format('woff2'),
          url('/fonts/fishmonger/fishmonger_700.ttf') format('truetype'),
          url('/fonts/fishmonger/fishmonger_700.otf') format('opentype');
      }
      @font-face {
        font-family: 'Poplar Kozel';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/PoplarKozel-Regular.woff2') format('woff2'),
        url('/fonts/PoplarKozel-Regular.ttf') format('truetype'),
        url('/fonts/PoplarKozel-Regular.otf') format('opentype');
      }
      @font-face {
        font-family: 'Poplar Kozel';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/PoplarKozel-Regular.woff2') format('woff2'),
        url('/fonts/PoplarKozel-Regular.ttf') format('truetype'),
        url('/fonts/PoplarKozel-Regular.otf') format('opentype');
      }
      @font-face {
        font-family: 'DIN pro';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/DIN_pro_condensed_bold.woff2') format('woff2'),
        url('/fonts/DIN_pro_condensed_bold.ttf') format('truetype'),
        url('/fonts/DIN_pro_condensed_bold.otf') format('opentype');
      }

      @font-face {
        font-family: 'AkzidenzGrotesk';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/pilsner/akzidenz_grotesk_900.ttf') format('woff2'),
        url('/fonts/pilsner/akzidenz_grotesk_900.ttf') format('truetype'),
        url('/fonts/pilsner/akzidenz_grotesk_900.ttf') format('opentype');
      }
      @font-face {
        font-family: 'AkzidenzGroteskSlim';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/pilsner/akzidenz_grotesk_slim_500.ttf') format('woff2'),
        url('/fonts/pilsner/akzidenz_grotesk_slim_500.ttf') format('truetype'),
        url('/fonts/pilsner/akzidenz_grotesk_slim_500.ttf') format('opentype');
      }
      @font-face {
        font-family: 'AkzidenzGroteskSlim';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/pilsner/akzidenz_grotesk_slim_900.ttf') format('woff2'),
        url('/fonts/pilsner/akzidenz_grotesk_slim_900.ttf') format('truetype'),
        url('/fonts/pilsner/akzidenz_grotesk_slim_900.ttf') format('opentype');
      }

      @font-face {
        font-family: 'Calibri';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/calibri_regular.woff2') format('woff2'),
          url('/fonts/calibri_regular.ttf') format('truetype'),
          url('/fonts/calibri_regular.otf') format('opentype');
      }
      @font-face {
        font-family: 'Calibri';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/calibri_bold.woff2') format('woff2'),
          url('/fonts/calibri_bold.ttf') format('truetype'),
          url('/fonts/calibri_bold.otf') format('opentype');
      }
      @font-face {
        font-family: 'Cairo';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/Cairo-Bold.ttf') format('truetype'),
      }

      @font-face {
        font-family: 'Museo Sans';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('/fonts/dreher/museo_sans_300.woff2') format('woff2'),
          url('/fonts/dreher/museo_sans_300.ttf') format('truetype'),
          url('/fonts/dreher/museo_sans_300.otf') format('opentype');
      }
      @font-face {
        font-family: 'Museo Sans';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/dreher/museo_sans_700.woff2') format('woff2'),
          url('/fonts/dreher/museo_sans_700.ttf') format('truetype'),
          url('/fonts/dreher/museo_sans_700.otf') format('opentype');
      }
      @font-face {
        font-family: 'Museo Slab';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/dreher/museo_slab_500.woff2') format('woff2'),
          url('/fonts/dreher/museo_slab_500.ttf') format('truetype'),
          url('/fonts/dreher/museo_slab_500.otf') format('opentype');
      }
      @font-face {
        font-family: 'Museo Slab';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/dreher/museo_slab_700.woff2') format('woff2'),
          url('/fonts/dreher/museo_slab_700.ttf') format('truetype'),
          url('/fonts/dreher/museo_slab_700.otf') format('opentype');
      }

      @font-face {
        font-family: 'Gotcha Gothic';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/raffo1/gotcha_gothic_400.woff2') format('woff2'),
          url('/fonts/raffo1/gotcha_gothic_400.ttf') format('truetype'),
          url('/fonts/raffo1/gotcha_gothic_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'Avant Garde Gothic';
        font-style: normal;
        font-weight: 300;
        font-display: swap;
        src: url('/fonts/raffo1/itc_avant_garde_gothic_300.woff2') format('woff2'),
          url('/fonts/raffo1/itc_avant_garde_gothic_300.ttf') format('truetype'),
          url('/fonts/raffo1/itc_avant_garde_gothic_300.otf') format('opentype');
      }
      @font-face {
        font-family: 'Avant Garde Gothic';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/raffo1/itc_avant_garde_gothic_700.woff2') format('woff2'),
          url('/fonts/raffo1/itc_avant_garde_gothic_700.ttf') format('truetype'),
          url('/fonts/raffo1/itc_avant_garde_gothic_700.otf') format('opentype');
      }

      @font-face {
        font-family: 'Knockout';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/ursus/knockout_400.woff2') format('woff2'),
          url('/fonts/ursus/knockout_400.ttf') format('truetype'),
          url('/fonts/ursus/knockout_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'Knockout';
        font-style: normal;
        font-weight: 500;
        font-display: swap;
        src: url('/fonts/ursus/knockout_500.woff2') format('woff2'),
          url('/fonts/ursus/knockout_500.ttf') format('truetype'),
          url('/fonts/ursus/knockout_500.otf') format('opentype');
      }
      @font-face {
        font-family: 'Knockout';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/ursus/knockout_700.woff2') format('woff2'),
          url('/fonts/ursus/knockout_700.ttf') format('truetype'),
          url('/fonts/ursus/knockout_700.otf') format('opentype');
      }
      @font-face {
        font-family: 'Gza';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/ursus/gza_400.woff2') format('woff2'),
          url('/fonts/ursus/gza_400.ttf') format('truetype'),
          url('/fonts/ursus/gza_400.otf') format('opentype');
        font-family: 'Mainlux';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/saris/mainlux_400.woff2') format('woff2'),
          url('/fonts/saris/mainlux_400.ttf') format('truetype'),
          url('/fonts/saris/mainlux_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'Mainlux';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/saris/mainlux_700.woff2') format('woff2'),
          url('/fonts/saris/mainlux_700.ttf') format('truetype'),
          url('/fonts/saris/mainlux_700.otf') format('opentype');
      }
      @font-face {
        font-family: 'Mainlux';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/saris/mainlux_900.woff2') format('woff2'),
          url('/fonts/saris/mainlux_900.ttf') format('truetype'),
          url('/fonts/saris/mainlux_900.otf') format('opentype');
      }

      @font-face {
        font-family: 'Avant Garde';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/peroni/itc_avant_garde.woff2') format('woff2'),
          url('/fonts/peroni/itc_avant_garde.ttf') format('truetype'),
          url('/fonts/peroni/itc_avant_garde.otf') format('opentype');
      }
      @font-face {
        font-family: 'Avant Garde';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/peroni/itc_avant_garde_700.woff2') format('woff2'),
          url('/fonts/peroni/itc_avant_garde_700.ttf') format('truetype'),
          url('/fonts/peroni/itc_avant_garde_700.otf') format('opentype');
      }

      @font-face {
        font-family: 'Alverata';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/alverata/alverata_900.woff2') format('woff2'),
          url('/fonts/alverata/alverata_900.ttf') format('truetype'),
          url('/fonts/alverata/alverata_900.otf') format('opentype');
      }

      @font-face {
        font-family: 'BwAletaNo20';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/bw_aleta_no_20/bw_aleta_no_20_400.woff2') format('woff2'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_400.ttf') format('truetype'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'BwAletaNo20';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/bw_aleta_no_20/bw_aleta_no_20_700.woff2') format('woff2'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_700.ttf') format('truetype'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_700.otf') format('opentype');
      }
      @font-face {
        font-family: 'BwAletaNo20';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/bw_aleta_no_20/bw_aleta_no_20_900.woff2') format('woff2'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_900.ttf') format('truetype'),
          url('/fonts/bw_aleta_no_20/bw_aleta_no_20_900.otf') format('opentype');
      }
      @font-face {
        font-family: 'Bebas Neue';
        font-style: normal;
        font-weight: 900;
        font-display: swap;
        src: url('/fonts/bebas_neue/bebas_neue_400.woff2') format('woff2'),
          url('/fonts/bebas_neue/bebas_neue_400.ttf') format('truetype'),
          url('/fonts/bebas_neue/bebas_neue_400.otf') format('opentype');
      }
      @font-face {
        font-family: 'Roboto Condensed';
        font-style: normal;
        font-weight: 400;
        font-display: swap;
        src: url('/fonts/RobotoCondensed-Regular.ttf') format('truetype');
      }
      @font-face {
        font-family: 'Roboto Condensed';
        font-style: normal;
        font-weight: 700;
        font-display: swap;
        src: url('/fonts/RobotoCondensed-Bold.ttf') format('truetype');
      }
    `}
  />
)
